import React from 'react'
import PropTypes from 'prop-types'
import {withRouter} from "react-router";
import { connect, Provider } from 'react-redux';
import LoginPage  from '../components/LoginPage';
import HashLogin from "../components/HashLogin";
import App from './App'

class CheckAuth extends React.Component {
    render() {
        if (!this.props.isLoggedIn && this.props.location.pathname.includes('hash-login')) {
            return <App />
        }

        //jeśli klient niezalogowany to pokazujemy stronę logowania
        if (!this.props.isLoggedIn) {
            return <LoginPage />
        }
        return <App />
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.user.isLoggedIn,
    };
};


export default connect(mapStateToProps, null)(withRouter(CheckAuth));
